module.exports = "https://portperrypedals.ca/_res/img/chevol.6ac4b42.png";